import { render, staticRenderFns } from "./BannersList.html?vue&type=template&id=3736b572&scoped=true&"
import script from "./BannersList.js?vue&type=script&lang=js&"
export * from "./BannersList.js?vue&type=script&lang=js&"
import style0 from "./BannersList.scss?vue&type=style&index=0&id=3736b572&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3736b572",
  null
  
)

export default component.exports